import { createSelector } from 'reselect';
import { BrandColorsState, ColorPalettesState } from './types';

export const colorPalettes = (state: any): ColorPalettesState => state.palettes;
export const colorPalettesFetching = (state: any) => colorPalettes(state).isFetching;

export const activeColorPalettes = createSelector(
    colorPalettes,
    (raw): ColorPalettesState => ({
        ...raw,
        palettes: raw.palettes
            .filter((palette) => !palette.deleted)
            .map((palette) => ({
                ...palette,
                brandColors: palette.brandColors.filter((c) => !c.deleted),
            })),
    }),
);

export const brandColors = (state: any): BrandColorsState => state.brandColors;

export const getPaletteActionProgress = createSelector(
    colorPalettes,
    (
        palettes,
    ): {
        createInProgress: ColorPalettesState['createInProgress'];
        editInProgress: ColorPalettesState['editInProgress'];
        deleteInProgress: ColorPalettesState['deleteInProgress'];
    } => ({
        createInProgress: palettes.createInProgress,
        editInProgress: palettes.editInProgress,
        deleteInProgress: palettes.deleteInProgress,
    }),
);

export const getBrandColorsActionProgress = createSelector(
    brandColors,
    (
        bc,
    ): {
        creatingInProgress: BrandColorsState['creatingInProgress'];
        editingInProgress: BrandColorsState['editingInProgress'];
        deleteInProgress: BrandColorsState['deleteInProgress'];
    } => ({
        creatingInProgress: bc.creatingInProgress,
        editingInProgress: bc.editingInProgress,
        deleteInProgress: bc.deleteInProgress,
    }),
);
